import { render } from "./Frequencies.vue?vue&type=template&id=3363ce5a"
import script from "./Frequencies.vue?vue&type=script&lang=js"
export * from "./Frequencies.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__